import React from 'react';
import Wordmark from './Wordmark';

// Shared page/card/logo shell for the standalone auth-style pages
// (signup, forgot/reset password, TpT arrival, email confirmation).
export default function AuthCard({ maxWidth = '400px', children }) {
  return (
    <div style={styles.page}>
      <div style={{ ...styles.card, maxWidth }}>
        <div style={styles.logo}><Wordmark /></div>
        {children}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#faf8f3',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    fontFamily: 'system-ui, -apple-system, sans-serif',
  },
  card: {
    backgroundColor: '#fff',
    border: '1px solid #e5e0d5',
    borderRadius: '12px',
    padding: '40px',
    width: '100%',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
  },
  logo: {
    marginBottom: '24px',
    letterSpacing: '-0.3px',
  },
};
